import { z } from 'zod'

type Translate = (key: string) => string

export function formatPairingCode(code: string): string {
  return code.length === 6 ? `${code.slice(0, 3)}-${code.slice(3)}` : code
}

export function registerDeviceSchema(t: Translate) {
  return z.object({
    name: z.string().min(1, { message: t('operations.addDevice.deviceNameRequiredError') }),
    branchId: z.string().min(1, { message: t('operations.addDevice.branchRequiredError') }),
  })
}

export function updateDeviceSchema(t: Translate) {
  return z.object({
    name: z.string().min(1, { message: t('operations.addDevice.deviceNameRequiredError') }),
    branchId: z.string(),
  })
}
